module.exports = __webpack_public_path__ + "img/norrtag-ordinarie.c20f2c22.png";